import React from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ReactTable from "react-table";
import Logger, {LOG_LEVELS} from '../../utils/logger';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import {TableConfig} from '../../utils/appConfig';

const log = new Logger('LIABILITIES_DETAILS', LOG_LEVELS.DEBUG);

const getCurrencyOptions = ()  => {
    return {
        filterMethod: (filter, row, column) => {
            return `${Number.parseFloat(row && row._original[filter.id]).toFixed(2)}`.includes(`${filter.value}`);
        },
        sortable: true,
        sortMethod: (a, b, desc) => {
            // force null and undefined to the bottom
            a = a && a.props ? a.props.value: a;
            b = b && b.props ? b.props.value: b;
            a = Number.parseFloat(a, 10);
            b = Number.parseFloat(b, 10);
            a = Number.isNaN(a) ? -Infinity :  a;
            b = Number.isNaN(b) ? -Infinity : b;        
            // Return either 1 or -1 to indicate a sort priority
            if (a > b) {
                return 1;
            }
            if (a < b) {
                return -1;
            }
            // returning 0 or undefined will use any subsequent column sorting methods or the row index as a tiebreaker
            return 0;
        },
        className: "text-align-right"
    }
}
export class LiabilitiesDetails extends React.Component {

    render() {
        log.debug('render(): ', this.props);

        const columns = [
            {
                id : 'taxPeriod',
                Header: props => <span><LanguageStringResolver string='Liabilities_Taxperiod'/></span>,
                accessor: d => 'From ' + d.taxPeriod.from + ' to ' + d.taxPeriod.to,
                filterable:true
            }, {
                Header: props => <span><LanguageStringResolver string='Liabilities_Type'/></span>,
                accessor: 'type',
                filterable:true
            }, {
                id: 'originalAmount',
                Header: props => <span><LanguageStringResolver string='Liabilities_OriginalAmount'/></span>,
                accessor: d =>  <FormattedCurrencyValue value={d.originalAmount} />,
                className: 'text-align-right',
                filterable:true,
                ...getCurrencyOptions()
            }, {
                id: 'outstandingAmount',
                Header:  props => <span><LanguageStringResolver string='Liabilities_OutstandingAmount'/></span>,
                accessor: d =>  <FormattedCurrencyValue value={d.outstandingAmount} />,
                className: 'text-align-right',
                filterable:true,
                ...getCurrencyOptions()
            }, {
                Header: props => <span><LanguageStringResolver string='Liabilities_Due'/></span>,
                accessor: 'due',
                filterable:true
            }]

            const NoDataComponent = props => (
                <NoData
                  noDataText="liabilitiesDetails_NoData"
                  {...props}
                />
              )

            return (
                <div>
                    <ReactTable
                        minRows={0}
                        maxRows={0}
                        data={this.props.data}
                        loading={this.props.loading}
                        columns={columns}
                        onFetchData={this.props.onFetchData}
                        showPageJump={false}
                        pages={this.props.pages}
                        NoDataComponent={NoDataComponent}
                        className={this.props.data && this.props.data.length === 0 ? 'mb15 hide-header' : 'mb15'}
                        PaginationComponent={Pagination}
                        showPagination={this.props.data && this.props.data.length === 0 ? false : true}
                        defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                        pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    />
                </div>
        )

    }
}


// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(LiabilitiesDetails);